import script from "./GetcalRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./GetcalRedirect.vue?vue&type=script&setup=true&lang=js"

import "./GetcalRedirect.vue?vue&type=style&index=0&id=78d0b195&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d0b195"]])

export default __exports__